import React, { memo, useState, useCallback, useMemo, useEffect } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import UserMarker from "./UserMarker";
import { useSelector } from "react-redux";
// import {  } from "@googlemaps/markerclusterer";
import { InfoWindow } from "@react-google-maps/api";
import "./MainComponent.css";

const containerStyle = {
  width: "100%",
  height: "555px",
};

const center = {
  lat: 21.164103,
  lng: 79.059302,
};

const MapComponent = memo(({ location }) => {
  // console.log("location in MapComponent", location);
  const { house } = useSelector((state) => state.liveTracking);
  const [selectedHouse, setSelectedHouse] = useState(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyD3BOe9dr06OEcgS6y6568CZooHZIHKLhM",
  });
  // const iconColor = houseType === "open plot" ? "#00BFFF" : "#EB00FF";

  const getOutlineHomeMarkerIcon = (color = "#22b7d1") => {
    if (!window?.google?.maps) return null;

    const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V9.5z"/>
    </svg>
  `.trim();

    return {
      url: require("./../../assets/icons/home_red.jpg"), // Use the SVG as a URL
      scaledSize: new window.google.maps.Size(20, 20),
      anchor: new window.google.maps.Point(10, 20),
    };
  };

  const [map, setMap] = useState(null);

  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback() {
    setMap(null);
  }, []);

  // Custom marker icon with proper memoization
  // const customMarkerIcon = useMemo(
  //   () => ({
  //     url: require("./../../assets/icons/home.png"),
  //     fillColor: "#EB00FF",
  //     scale: 0.5,
  //   }),
  //   []
  // );
  const customOpenPlotIcon = useMemo(
    () => ({
      url: require("./../../assets/img/openPlot.png"),
      fillColor: "#EB00FF",
      scale: 0.3,
    }),
    []
  );

  useEffect(() => {
    console.log("House data updated:", house);
  }, [house]);

  const customMarkerIcon = useMemo(() => {
    if (!isLoaded || !window.google?.maps) return null;
    return getOutlineHomeMarkerIcon("#0b4c57");
  }, [isLoaded]);

  const groupedHouses = useMemo(() => {
    const map = new Map();

    house?.forEach((loc) => {
      if (!loc.latitude || !loc.longitude) return;

      const key = `${loc._id}_${loc.latitude}_${loc.longitude}`;
      const positionKey = `${loc.latitude}_${loc.longitude}`;

      if (!map.has(positionKey)) {
        map.set(positionKey, []);
      }

      map.get(positionKey).push(loc); // Push all owners with same location
    });

    return Array.from(map.values()); // Each item is now an array of houses at same location
  }, [house]);

  const residents = useMemo(() => {
    if (!selectedHouse) return [];
    const owners = house.filter(
      (h) =>
        h?._id === selectedHouse?._id &&
        h?.latitude === selectedHouse?.latitude &&
        h?.longitude === selectedHouse?.longitude
    );

    return owners;
  }, [selectedHouse, house]);

  const getHomeIconByColor = (color) => {
    if (!window?.google?.maps) return null;

    let file;
    switch (color) {
      case "green":
        file = require("./../../assets/icons/home_green.jpg");
        break;
      case "yellow":
        file = require("./../../assets/icons/home_yellow.png");
        break;
      case "red":
      default:
        file = require("./../../assets/icons/home_red.jpg");
        break;
    }

    return {
      url: file,
      scaledSize: new window.google.maps.Size(25, 25),
      anchor: new window.google.maps.Point(10, 20),
    };
  };

  const getMarkerIconForHouse = (housesAtSameLocation) => {
    if (!window.google?.maps) return null;

    const firstHouse = housesAtSameLocation[0];
    const isFlatscheme = firstHouse.houseType === "flatscheme";

    if (isFlatscheme) {
      const total = housesAtSameLocation.length;
      const collected = housesAtSameLocation.filter(
        (h) => h.isCollected
      ).length;

      if (collected === 0) return getHomeIconByColor("red");
      if (collected === total) return getHomeIconByColor("green");
      return getHomeIconByColor("yellow");
    }

    // For individual houses (residential/commercial)
    const isCollected = firstHouse?.isCollected ?? false;
    return getHomeIconByColor(isCollected ? "green" : "red");
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {/* <UserMarker
          zoneId={zoneId}
          trackId={trackId}
          latitude={memoizedUserLatitude}
          longitude={memoizedUserLongitude}
        /> */}

      {/* {memoizedTracks.length > 0 &&
        memoizedTracks.map((locationArray, locationIndex) =>
          locationArray?.trackCords?.map((track, trackIndex) => {
            const key = ${locationIndex}-${trackIndex};
            const waypoints = track.slice(1, -1).map((loc) => ({
              location: { lat: loc.latitude, lng: loc.longitude },
              stopover: false,
            }));

            return (
              <React.Fragment key={key}>
                <DirectionsService
                  options={{
                    origin: {
                      lat: track[0].latitude,
                      lng: track[0].longitude,
                    },
                    destination: {
                      lat: track[track.length - 1].latitude,
                      lng: track[track.length - 1].longitude,
                    },
                    waypoints: waypoints,
                    travelMode: "DRIVING",
                  }}
                  callback={(response) =>
                    handleDirectionsServiceCallback(response, key)
                  }
                />
                {directionsResponses[key] && (
                  <DirectionsRenderer
                    options={{
                      directions: directionsResponses[key],
                      preserveViewport: true,
                      suppressMarkers: true,
                    }}
                  />
                )}
                <Marker
                  position={{
                    lat: track[0].latitude,
                    lng: track[0].longitude,
                  }}
                  icon={customMarkerIcon}
                />
                <Marker
                  position={{
                    lat: track[track.length - 1].latitude,
                    lng: track[track.length - 1].longitude,
                  }}
                  icon={customMarkerIcon}
                />
              </React.Fragment>
            );
          })
        )} */}

      {location?.map((loc, index) => (
        <UserMarker key={index} location={loc} />
      ))}

      <MarkerClusterer>
        {(clusterer) =>
          groupedHouses.map((housesAtSameLocation, index) => {
            const firstHouse = housesAtSameLocation[0];

            return (
              <Marker
                key={index}
                position={{
                  lat: Number(firstHouse.latitude),
                  lng: Number(firstHouse.longitude),
                }}
                icon={getMarkerIconForHouse(housesAtSameLocation)}
                clusterer={clusterer}
                onClick={() => setSelectedHouse(firstHouse)}
              />
            );
          })
        }
      </MarkerClusterer>

      {/* Selected marker as InfoWindow (without base marker) */}
      {selectedHouse && (
        <InfoWindow
          position={{
            lat: Number(selectedHouse.latitude),
            lng: Number(selectedHouse.longitude),
          }}
          onCloseClick={() => setSelectedHouse(null)}
        >
          <div
            style={{
              minWidth: "260px",
              padding: "12px 16px",
              lineHeight: "1.5",
            }}
          >
            {selectedHouse?.houseType === "flatscheme" ? (
              <>
                <h4 style={{ marginBottom: "8px" }}>Flatscheme Residents</h4>
                {residents?.map((r, i) => {
                  const iconSrc = r?.isCollected
                    ? require("./../../assets/icons/home_green.jpg")
                    : require("./../../assets/icons/home_red.jpg");

                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 6,
                      }}
                    >
                      <img
                        src={iconSrc}
                        alt={r?.isCollected ? "green house" : "red house"}
                        width={16}
                        height={16}
                        style={{ marginRight: 8, borderRadius: "50%" }}
                        className="blinking-icon"
                      />
                      <strong>{r?.ownerName}</strong> - {r?.plotNo}
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                <h4 style={{ marginBottom: "8px" }}>
                  {selectedHouse?.ownerName}
                </h4>
                <p style={{ marginBottom: "6px" }}>
                  Plot No: {selectedHouse?.plotNo}
                </p>
                {/* <p>House Type: {selectedHouse?.houseType}</p>
                <p>Zone ID: {selectedHouse?.zoneId}</p> */}
              </>
            )}
          </div>
        </InfoWindow>
      )}

      {/* {house?.map((loc, index) => {
        return (
          <Marker
            key={index}
            title={loc.ownerName}
            position={{
              lat: Number(loc.latitude),
              lng: Number(loc.longitude),
            }}
            icon={
              loc.houseType === "open plot"
                ? customOpenPlotIcon
                : customMarkerIcon
            }
          />
        );
      })} */}
    </GoogleMap>
  ) : null;
});

// // Prevent TrackMap from re-rendering unless trackId or zoneId change
// const areEqual = (prevProps, nextProps) => {
//   return prevProps.tracks.length === nextProps.tracks.length;
// };
// export default memo(MapComponent, areEqual);
export default MapComponent;
